import {CLEAR_ORDERS_HISTORY, LOAD_ORDERS_HISTORY_SUCCESS} from '../../../actions/types';

const INITIAL_STATE = {
	content: []
};

export default (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_ORDERS_HISTORY_SUCCESS:
            return action.payload;
        case CLEAR_ORDERS_HISTORY:
            return INITIAL_STATE;
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/restaurants/orders/OrdersHistoryReducer.js